import { Navigate, useParams } from "react-router-dom";
import { slugify } from "../lib/slugify";

// Legacy /events/city/:city (name-based) → new canonical /city/:slug.
export default function CityRedirect() {
  const { city } = useParams();
  return <Navigate to={`/city/${slugify(decodeURIComponent(city || ""))}`} replace />;
}
